import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  StaffingRuleView,
} from './types/laborManagementTypes';

interface LaborManagementState {
  // Selection context
  selectedCompany: string;
  selectedCenterId: string;
  selectedYear: number;

  // Edit drafts (Trackly-style: hydrate from API, edit locally, submit)
  editingStaffingRule: StaffingRuleView | null;

  // Track which fields have been edited
  editedFields: Record<string, string[]>;
}

const initialState: LaborManagementState = {
  selectedCompany: '',
  selectedCenterId: '',
  selectedYear: new Date().getFullYear(),

  editingStaffingRule: null,

  editedFields: {},
};

const laborManagementSlice = createSlice({
  name: 'laborManagement',
  initialState,
  reducers: {
    // Selection context
    setSelectedFacility(state, action: PayloadAction<{ company: string; centerId: string }>) {
      state.selectedCompany = action.payload.company;
      state.selectedCenterId = action.payload.centerId;
    },
    setSelectedYear(state, action: PayloadAction<number>) {
      state.selectedYear = action.payload;
    },

    // Edit drafts
    setEditingStaffingRule(state, action: PayloadAction<StaffingRuleView | null>) {
      state.editingStaffingRule = action.payload;
    },

    // Field tracking
    markFieldEdited(state, action: PayloadAction<{ entity: string; field: string }>) {
      const { entity, field } = action.payload;
      if (!state.editedFields[entity]) {
        state.editedFields[entity] = [];
      }
      if (!state.editedFields[entity].includes(field)) {
        state.editedFields[entity].push(field);
      }
    },
    clearEditedFields(state, action: PayloadAction<string>) {
      delete state.editedFields[action.payload];
    },

    // Reset
    resetLaborState() {
      return initialState;
    },
  },
});

export const {
  setSelectedFacility,
  setSelectedYear,
  setEditingStaffingRule,
  markFieldEdited,
  clearEditedFields,
  resetLaborState,
} = laborManagementSlice.actions;

export default laborManagementSlice.reducer;
